import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito saber de finanzas para aplicar esto?',
  a: 'No. El Método Caudal está diseñado para personas que parten de cero. Si sabés cuánto ganás y cuánto gastás, tenés todo lo que necesitás para empezar.'
}, {
  q: '¿Funciona con sueldos bajos?',
  a: 'Sí. El Sistema de Presupuesto Inverso no requiere un ingreso mínimo. Funciona con cualquier monto porque trabaja con proporciones, no con cifras absolutas.'
}, {
  q: '¿Cuándo recibo los materiales?',
  a: 'Inmediatamente después de tu compra. Los 6 tomos llegan a tu email en minutos.'
}, {
  q: '¿Qué pasa si no me funciona?',
  a: 'Tenés 30 días para aplicarlo y comprobarlo. Si no ves ningún cambio, te devolvemos el dinero completo. Sin preguntas.'
}, {
  q: '¿Esto es para Argentina específicamente?',
  a: 'Los principios aplican a cualquier país hispanohablante. Los ejemplos y contexto están adaptados a la realidad del asalariado en Argentina.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-[#0F0F0F]" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <div className="text-center mb-12" data-id="element-72">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-73">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-74">
          {faqs.map((faq, index) => <div key={index} className="bg-[#141414] border border-gray-800 rounded-xl overflow-hidden" data-id="element-75">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-76">
                <span className="font-semibold text-white text-lg pr-8" data-id="element-77">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold-500 shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-78" />
              </button>

              <div className={`grid transition-all duration-300 ease-in-out ${openIndex === index ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-79">
                <div className="overflow-hidden" data-id="element-80">
                  <div className="px-6 pb-5 text-gray-300 leading-relaxed" data-id="element-81">
                    {faq.a}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}